
import _ from 'lodash';

function getLossDamage(vmDTO, response, isCommercial, claimVM, updateWizardData, refreshData) {
    const extHome = _.get(claimVM, 'lossDamagesExt.value[0].exteriorDamage');
    const intHome = _.get(claimVM, 'lossDamagesExt.value[0].interiorDamage');
    const personalDamage = _.get(claimVM, 'lossDamagesExt.value[0].personalPropertyDamage');
    const homeUnlievable = _.get(claimVM, 'lossDamagesExt.value[0].homeUnliveable');
    const emergenceServ = _.get(claimVM, 'lossDamagesExt.value[0].emergenceServices');
    const businessOptSuspended = _.get(claimVM, 'lossDamagesExt.value[0].businessOptSuspended') || false;

    const lossItemDetails = vmDTO(response);

    lossItemDetails.description.value = _.get(claimVM, 'description.value');
    lossItemDetails.anyDamage.value = true;
    lossItemDetails.businessOptSuspended.value = false;
    // Emergency Services
    lossItemDetails.emergenceServices.value = false;
    lossItemDetails.emergenceServicesBoardUp.value = false;
    lossItemDetails.emergenceServicesRoofTarp.value = false;
    lossItemDetails.emergenceServicesTreeRemoval.value = false;
    lossItemDetails.emergenceServicesWaterMitigat.value = false;
    lossItemDetails.emergenceServicesUtilFailure.value = false;
    // Exterior Damage
    lossItemDetails.exteriorDamage.value = false;
    lossItemDetails.exteriorDamageRoof.value = false;
    lossItemDetails.exteriorDamageDoorWindow.value = false;
    lossItemDetails.exteriorDamageFence.value = false;
    lossItemDetails.exteriorDamageHVAC.value = false;
    lossItemDetails.exteriorDamageWalls.value = false;
    lossItemDetails.exteriorDamageUtilities.value = false;
    lossItemDetails.exteriorDamageDetachedGarage.value = false;
    lossItemDetails.exteriorDamagePoolEnclosure.value = false;
    lossItemDetails.exteriorDamagePool.value = false;
    lossItemDetails.exteriorDamageCarport.value = false;
    lossItemDetails.exteriorDamageOtherStructure.value = false;
    // Interior Damage
    lossItemDetails.interiorDamage.value = false;
    lossItemDetails.interiorDamage2Rooms.value = false;
    lossItemDetails.interiorDamage3Rooms.value = false;
    // Personal property damage
    lossItemDetails.personalPropertyDamage.value = false;
    // Home Unlivable?
    lossItemDetails.homeUnliveable.value = false;
    // lossItemDetails = lossItemDetails;
    lossItemDetails.policyLocation.value = response.policyLocation;

    if (!isCommercial) {
        lossItemDetails.LocationBasedRU = response.locationBasedRU;
        claimVM.lossDamagesExt.value.push(lossItemDetails.value)
    }

    if (isCommercial) {
        lossItemDetails.exteriorDamage.value = extHome;
        lossItemDetails.interiorDamage.value = intHome
        lossItemDetails.personalPropertyDamage.value = personalDamage
        lossItemDetails.homeUnliveable.value = homeUnlievable
        lossItemDetails.emergenceServices.value = emergenceServ
        lossItemDetails.businessOptSuspended.value = businessOptSuspended
        lossItemDetails.locationBasedRU = claimVM.lossDamagesExt.value[0].locationBasedRU
        claimVM.lossDamagesExt.value[0] = lossItemDetails.value
    }

    updateWizardData(claimVM);
    refreshData();

    return claimVM;


}

function getLossDamageCommercial(vmDTO, response, isCommercial, claimVM, updateWizardData, newLossDamage, refreshData, isAdditional) {

    const lossDamages = [];
    const extHome = _.get(claimVM, 'lossDamagesExt.value[0].exteriorDamage');
    const intHome = _.get(claimVM, 'lossDamagesExt.value[0].interiorDamage');
    const personalDamage = _.get(claimVM, 'lossDamagesExt.value[0].personalPropertyDamage');
    const homeUnlievable = _.get(claimVM, 'lossDamagesExt.value[0].homeUnliveable');
    const emergenceServ = _.get(claimVM, 'lossDamagesExt.value[0].emergenceServices');
    const businessOptSuspended = _.get(claimVM, 'lossDamagesExt.value[0].businessOptSuspended');

    response.forEach(item => {
        const lossItemDetails = vmDTO(item);

        lossItemDetails.description.value = _.get(claimVM, 'description.value');
        lossItemDetails.anyDamage.value = true;
        // Emergency Services
        lossItemDetails.emergenceServices.value = false;
        lossItemDetails.emergenceServicesBoardUp.value = false;
        lossItemDetails.emergenceServicesRoofTarp.value = false;
        lossItemDetails.emergenceServicesTreeRemoval.value = false;
        lossItemDetails.emergenceServicesWaterMitigat.value = false;
        lossItemDetails.emergenceServicesUtilFailure.value = false;
        // Exterior Damage
        lossItemDetails.exteriorDamage.value = false;
        lossItemDetails.exteriorDamageRoof.value = false;
        lossItemDetails.exteriorDamageDoorWindow.value = false;
        lossItemDetails.exteriorDamageFence.value = false;
        lossItemDetails.exteriorDamageHVAC.value = false;
        lossItemDetails.exteriorDamageWalls.value = false;
        lossItemDetails.exteriorDamageUtilities.value = false;
        lossItemDetails.exteriorDamageDetachedGarage.value = false;
        lossItemDetails.exteriorDamagePoolEnclosure.value = false;
        lossItemDetails.exteriorDamagePool.value = false;
        lossItemDetails.exteriorDamageCarport.value = false;
        lossItemDetails.exteriorDamageOtherStructure.value = false;
        // Interior Damage
        lossItemDetails.interiorDamage.value = false;
        lossItemDetails.interiorDamage2Rooms.value = false;
        lossItemDetails.interiorDamage3Rooms.value = false;
        // Personal property damage
        lossItemDetails.personalPropertyDamage.value = false;
        // Home Unlivable?
        lossItemDetails.homeUnliveable.value = false;
        // lossItemDetails = lossItemDetails;
        lossItemDetails.policyLocation.value = response.policyLocation;


        if (isCommercial && newLossDamage) {
            if(newLossDamage.length > 0) {
            lossItemDetails.exteriorDamage.value = newLossDamage[0].exteriorDamage;
            lossItemDetails.interiorDamage.value = newLossDamage[0].interiorDamage
            lossItemDetails.personalPropertyDamage.value = newLossDamage[0].personalPropertyDamage
            lossItemDetails.homeUnliveable.value = newLossDamage[0].homeUnliveable
            lossItemDetails.emergenceServices.value = newLossDamage[0].emergenceServices
            lossItemDetails.businessOptSuspended.value = newLossDamage[0].businessOptSuspended
            }
        }

        if (isCommercial && isAdditional) {
            lossItemDetails.exteriorDamage.value = extHome;
            lossItemDetails.interiorDamage.value = intHome
            lossItemDetails.personalPropertyDamage.value = personalDamage
            lossItemDetails.homeUnliveable.value = homeUnlievable
            lossItemDetails.emergenceServices.value = emergenceServ
            lossItemDetails.businessOptSuspended.value = businessOptSuspended // DE16781
        }

        lossDamages.push(lossItemDetails.value);

        // if (!isCommercial) {
        //     lossItemDetails.LocationBasedRU = response.locationBasedRU;
        //     claimVM.lossDamagesExt.value.push(lossItemDetails.value)
        // }

        if (isCommercial && !isAdditional) {
            lossItemDetails.locationBasedRU = item
            // lossItemDetails.locationBasedRU = claimVM.lossDamagesExt.value[0].locationBasedRU

        }

        claimVM.lossDamagesExt.value = lossDamages

    });
    updateWizardData(claimVM);
    refreshData();

    return claimVM
}

export default {
    getLossDamage,
    getLossDamageCommercial
};
